import { gateDocumentActionTypes } from '../../../actions/logistics/gateDocument/gateDocumentActions';

const GateDocumentReducers = (state = {}, action) => {
  switch (action.type) {
    case gateDocumentActionTypes.GET_GATE_DOCUMENT_BY_ID.LOADING: {
      const { getGateDocumentByIdLoading } = action;
      return {
        ...state,
        getGateDocumentByIdLoading,
      };
    }
    case gateDocumentActionTypes.GET_GATE_DOCUMENT_BY_ID.SUCCESS: {
      const { selectedGateDocument } = action;
      return {
        ...state,
        selectedGateDocument,
      };
    }
    case gateDocumentActionTypes.CREATE_GATE_DOCUMENT.LOADING: {
      const { createGateDocumentLoading } = action;
      return {
        ...state,
        createGateDocumentLoading,
      };
    }
    case gateDocumentActionTypes.GET_GATE_DOCUMENTS.SUCCESS: {
      const { gateDocuments } = action;
      return {
        ...state,
        gateDocuments,
      };
    }
    case gateDocumentActionTypes.GET_GATE_DOCUMENTS.LOADING: {
      const { getGateDocumentsLoading } = action;
      return {
        ...state,
        getGateDocumentsLoading,
      };
    }
    case gateDocumentActionTypes.LINK_CONTACTS.LOADING: {
      const { linkContactsLoading } = action;
      return {
        ...state,
        linkContactsLoading,
      };
    }
    case gateDocumentActionTypes.UNLINK_CONTACTS.LOADING: {
      const { unlinkContactsLoading } = action;
      return {
        ...state,
        unlinkContactsLoading,
      };
    }
    case gateDocumentActionTypes.LINK_DOCUMENTS.LOADING: {
      const { linkDocumentsLoading } = action;
      return {
        ...state,
        linkDocumentsLoading,
      };
    }
    case gateDocumentActionTypes.UNLINK_DOCUMENTS.LOADING: {
      const { unlinkDocumentsLoading } = action;
      return {
        ...state,
        unlinkDocumentsLoading,
      };
    }
    case gateDocumentActionTypes.UPDATE_DOCUMENT_STATUS.LOADING: {
      const { updateDocumentStatusLoading } = action;
      return {
        ...state,
        updateDocumentStatusLoading,
      };
    }
    default: {
      return state;
    }
  }
};

export default GateDocumentReducers;
